<!-- 销售订单出仓 -->
<template>
    <div class="warehouseOut" v-loading="dailogLoading">
        <div class="dialog-header" v-if="tcckType == 1">
            <div>
                <el-button v-if="!isTcckModel" class="btn-primary" size="small" @click="isTcckModel = true">同仓出库</el-button>
                <el-select
                    v-if="isTcckModel"
                    v-model="tcckWarehouseId"
                    size="small"
                    filterable
                    clearable
                    :disabled="isSaleOutOrderOut"
                    @visible-change="track_wHVisibleChange($event)"
                    @change="
                        val => {
                            (tcckShelfSpaceId = ''), (tcckShelfSpaceOptions = []);
                        }
                    "
                    style="margin-right: 20px"
                >
                    <el-option v-for="optionItem in tcckWarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" :key="optionItem.WarehouseId"> </el-option>
                </el-select>
                <el-select
                    v-if="isTcckModel"
                    v-model="tcckShelfSpaceId"
                    :loading="loading"
                    filterable
                    clearable
                    reserve-keyword
                    remote
                    :remote-method="value => tcrkRemoteMethod(value, tcckWarehouseId)"
                    @visible-change="
                        value => {
                            if (value && tcckShelfSpaceOptions.length == 0) tcrkRemoteMethod('', tcckWarehouseId);
                        }
                    "
                    @change="tcckShelfSpaceChange"
                    size="small"
                >
                    <el-option v-for="item in tcckShelfSpaceOptions" :key="item.ShelfSpaceId" :label="item.ShelfSpaceCode" :value="item.ShelfSpaceId"> </el-option>
                </el-select>
            </div>
            <div v-if="isTcckModel">
                <el-button size="small" @click="isTcckModel = false">取消</el-button>
                <el-button class="btn-primary" size="small" @click="submitData">出仓</el-button>
            </div>
        </div>
        <div class="tips" v-if="tcckType == 1">可批量默认整单商品同一仓位出库，仓位下商品不足时可更换其他仓位出库</div>
        <div class="warehouseOut-main">
            <el-table
                ref="refTable"
                :data="goodsList"
                :span-method="objectSpanMethod"
                border
                style="width: 100%; margin: 0"
                :row-style="setRowStyle"
                :header-cell-style="{ background: '#F2F6FC' }"
            >
                <el-table-column prop="GoodName" label="配件名称" width="180" key="2"></el-table-column>
                <el-table-column prop="APCode" label="配件编码" width="180" key="3"></el-table-column>
                <el-table-column prop="WarehouseId" label="仓库" key="4">
                    <template slot-scope="scope">
                        <el-select
                            v-model="scope.row.WarehouseId"
                            size="small"
                            filterable
                            clearable
                            :loading="loading"
                            :disabled="isSaleOutOrderOut"
                            reserve-keyword
                            @visible-change="wHVisibleChange($event, scope.row)"
                            @change="warehouseChange($event, scope.row)"
                        >
                            <el-option
                                :key="index"
                                v-for="(optionItem, index) in scope.row.WarehouseList"
                                :label="optionItem.WarehouseName"
                                :value="optionItem.WarehouseId"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="ShelfSpaceId" label="仓位" key="5">
                    <template slot-scope="scope">
                        <el-select
                            v-model="scope.row.ShelfSpaceId"
                            value-key="ShelfSpaceId"
                            :loading="loading"
                            filterable
                            clearable
                            reserve-keyword
                            remote
                            :remote-method="val => remoteMethod(val, scope.row)"
                            @change="positionChange($event, scope.row)"
                            @visible-change="positionVisibleChange($event, scope.row)"
                            @clear="positionClear(scope.row)"
                            no-data-text="无存放仓位"
                            no-match-text="无存放仓位"
                            size="small"
                        >
                            <el-option
                                :key="optionItem.ShelfSpaceId"
                                v-for="optionItem in scope.row.ShelfSpacesList"
                                :label="optionItem.ShelfSpaceCode"
                                :value="optionItem.ShelfSpaceId"
                            >
                                <span style="display: inline-block; width: 150px">{{ optionItem.ShelfSpaceCode }}</span>
                                <span v-if="!isNaN(optionItem.Count)">库存:{{ optionItem.Count }}</span>
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column prop="Count" label="数量" key="6">
                    <template slot-scope="scope">
                        <el-input size="small" type="number" v-model="scope.row.Count" :min="0" />
                    </template>
                </el-table-column>
                <el-table-column label="操作" key="7">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-minus" @click="delItem(scope.$index, scope.row)"> </el-button>
                        <el-button size="mini" icon="el-icon-plus" @click="addItem(scope.$index, scope.row)"> </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-footer" v-if="!isTcckModel">
            <el-button size="small" @click="cancel" :disabled="dailogLoading">取消</el-button>
            <el-button class="btn-primary" size="small" :disabled="dailogLoading" @click="submitData">出仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['tcckType', 'APList', 'EntpCusOId', 'OrderWarehouse','ZoneId','SaleOutOrderOut'], //OrderWarehouse:订单选择的仓库 //SaleOutOrderOut：是销售出库单的出库
    components: {},
    data() {
        return {
            dailogLoading: true,
            loading: false,
            WarehouseList: [],
            PositionList: [],
            searchPositionReq: {
                WarehouseId: '',
                ShelfSpaceCode: '',
                GoodsId: '',
                SortField: 'SpaceType',
                SortType: 'asc',
                Page: 1,
                Limit: 20
            },
            formData: {
                EntpCusOId: this.EntpCusOId,
                GoodsList: [
                    {
                        EntpTempGoodsId: '',
                        GoodsLocationList: [
                            {
                                ShelfSpaceId: '',
                                Count: ''
                            }
                        ]
                    }
                ]
            },
            goodsList: [], //入仓商品列表
            isSaleOutOrderOut:false,
            isTcckModel: false, // 是否开启同仓出库模式
            tcckWarehouseId: '', // 同仓入库仓库信息
            tcckShelfSpaceId: '', // 同仓入库仓位信息
            tcckWarehouseList: [],
            tcckShelfSpaceOptions: [], // 同仓入库仓位列表
            spanArr: [],
            pos: 0
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let that = this;
            if(this.SaleOutOrderOut){
                this.isSaleOutOrderOut = true;
            }
            //处理出仓数据
            let _APList = [];
            for (let i = 0; i < that.APList.length; i++) {
                if (!that.APList[i].IsDelivery) {
                    // 可出仓数等于商品总数减去已经出仓数量
                    let Count = that.APList[i].Count - that.APList[i].WarehousedCount;
                    _APList.push({
                        EntpTempGoodsId: that.APList[i].EntpTempGoodsId,
                        GoodName: that.APList[i].GoodName,
                        APCode: that.APList[i].APCode,
                        Count,
                        canOutCount: Count,
                        WarehousedCount: that.APList[i].WarehousedCount,
                        ShelfSpaceId: '',
                        ShelfSpacesList: [],
                        WarehouseId: that.OrderWarehouse && that.OrderWarehouse.WarehouseId ? that.OrderWarehouse.WarehouseId : '',
                        WarehouseList: that.OrderWarehouse && that.OrderWarehouse.WarehouseId ? [{ ...that.OrderWarehouse }] : []
                    });
                }
            }
            that.goodsList = _APList;
            that.getSpanArr();
            that.dailogLoading = false;
            that.track_wHVisibleChange(true);
        },
        track_wHVisibleChange(val) {
            if (!val || this.tcckWarehouseList.length > 0) return;
            this.$util.getWarehouse().then(data => {
                this.tcckWarehouseList = data;
                setTimeout(() => {
                    if (this.goodsList.length !== 0) {
                        this.tcckWarehouseId = this.goodsList[0].WarehouseId;
                    }
                }, 200);
            });
        },
        // 同仓出库搜索仓位
        tcrkRemoteMethod(value, tcckWarehouseId) {
            if (!tcckWarehouseId) return;
            let that = this;
            that.loading = true;
            that.$util
                .GetShelfSpacesList({
                    WarehouseId: tcckWarehouseId,
                    ShelfSpaceCode: value,
                    ZoneId:that.ZoneId,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: true
                })
                .then(res => {
                    that.loading = false;
                    if (res.data) {
                        that.tcckShelfSpaceOptions = res.data;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.loading = false;
                });
        },
        // 同仓出库选择仓位
        async tcckShelfSpaceChange(key) {
            this.dailogLoading = true;
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpShelfSpaces/GetGoodsInSpaceCount',
                data: {
                    shelfSpaceId: key,
                    goodsIds: this.goodsList.map(m => m.EntpTempGoodsId)
                },
                hideLoading: true
            });
            this.dailogLoading = false;
            /**
             * 展示库存数
             * 去除重复商品项
             * 用同库出仓选择的数据，覆盖仓库，仓库列表，仓位，仓位列表
             */
            let _goodsList = [];
            this.goodsList.forEach(ele => {
                if (_goodsList.findIndex(f => f.EntpTempGoodsId === ele.EntpTempGoodsId) === -1) {
                    let gIdx = data.findIndex(f => f.GoodsId === ele.EntpTempGoodsId);
                    let tIdx = this.tcckShelfSpaceOptions.findIndex(f => f.ShelfSpaceId === key);
                    let wIdx = ele.WarehouseList.findIndex(f => f.WarehouseId === this.tcckWarehouseId);
                    let twIdx = this.tcckWarehouseList.findIndex(f => f.WarehouseId === this.tcckWarehouseId);
                    let param = {
                        ...ele,
                        WarehouseId: this.tcckWarehouseId,
                        WarehouseList: wIdx > -1 ? ele.WarehouseList : [...ele.WarehouseList, this.tcckWarehouseList[twIdx]],
                        ShelfSpaceId: this.tcckShelfSpaceId,
                        KcCount: gIdx > -1 ? data[gIdx].Count : 0,
                        ShelfSpacesList: []
                    };
                    if (this.tcckShelfSpaceOptions[tIdx]) {
                        param.ShelfSpacesList = [
                            {
                                ...this.tcckShelfSpaceOptions[tIdx],
                                Count: gIdx > -1 ? data[gIdx].Count : 0
                            }
                        ];
                    }
                    _goodsList.push(param);
                }
            });
            this.goodsList = _goodsList;
        },
        //仓库下拉框出现/隐藏时触发
        wHVisibleChange(val, goods) {
            if (!val) return;
            let that = this;
            if (!goods.WarehouseList || goods.WarehouseList.length <= 1) {
                that.loading = true;
                that.$util.getWarehouseByGId(goods.EntpTempGoodsId).then(data => {
                    let newW = data;
                    let w = goods.WarehouseList.length > 0 ? goods.WarehouseList[0] : '';
                    if (w) {
                        let exit = data.find(e => e.WarehouseId == w.WarehouseId);
                        if (!exit) {
                            newW = goods.WarehouseList.concat(newW);
                        }
                    }
                    that.$set(goods, 'WarehouseList', newW);
                    that.loading = false;
                });
            }
        },
        //仓位下拉框出现/隐藏时触发
        positionVisibleChange(val, goods) {
            if (!val || !goods.WarehouseId) return;
            let that = this;
            if (!(goods.ShelfSpacesList && goods.ShelfSpacesList.length > 0)) {
                that.searchPositionReq.WarehouseId = goods.WarehouseId;
                that.searchPositionReq.ShelfSpaceCode = '';
                that.searchPositionReq.GoodsId = goods.EntpTempGoodsId;
                that.searchPositionReq.ZoneId = that.ZoneId;
                that.searchPositionReq.Page = 1;
                that.searchPosition(that.searchPositionReq).then(resp => {
                    let newArr = [];
                    if (resp.data) newArr = resp.data;
                    that.$set(goods, 'ShelfSpacesList', newArr);
                    that.loading = false;
                });
            }
        },
        positionClear(goods) {
            goods.ShelfSpacesList = [];
        },
        remoteMethod(val, goods) {
            if (!val || !goods.WarehouseId) return;
            let that = this;
            that.searchPositionReq.WarehouseId = goods.WarehouseId;
            that.searchPositionReq.ShelfSpaceCode = val;
            that.searchPositionReq.ZoneId = that.ZoneId;
            that.searchPositionReq.GoodsId = goods.EntpTempGoodsId;
            that.searchPositionReq.Page = 1;
            that.searchPosition(that.searchPositionReq).then(resp => {
                let newArr = [];
                if (resp.data) newArr = resp.data;
                that.$set(goods, 'ShelfSpacesList', newArr);
                that.loading = false;
            });
        },
        // 搜仓位
        searchPosition(req) {
            let that = this;
            if (!req.WarehouseId || that.loading) return;
            that.loading = true;
            return new Promise(resolve => {
                this.$util
                .axiosGet({
                    url: '/api/EntpShelfSpaces/GetShelfSpacesListByGoodsId',
                    data: that.searchPositionReq,
                    hideLoading: true
                })
                .then(res => {
                    resolve(res);

                });
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        submitData() {
            let that = this;
            let _data = [];
            for (let i = 0; i < that.goodsList.length; i++) {
                let row = that.goodsList[i];
                if (!row.ShelfSpaceId) {
                    that.$util.warningMsg('请选择仓位');
                    return;
                }
                if (row.Count <= 0) {
                    that.$util.warningMsg('出库数量必须大于零');
                    return;
                }
                let tIdx = row.ShelfSpacesList.findIndex(f => f.ShelfSpaceId === row.ShelfSpaceId);
                if (row.Count > row.ShelfSpacesList[tIdx].Count) {
                    that.$util.warningMsg('数量不得大于库存数量');
                    return;
                }
                // EV：已选仓位商品的出仓总数
                let EV = that.goodsList.filter(f => f.EntpTempGoodsId == row.EntpTempGoodsId).reduce((r, i) => r + i.Count * 1, 0);
                if (row.canOutCount < EV) {
                    that.$util.warningMsg('出库数量不可以超过未出库数量');
                    return;
                }
                let intCount = Number(row.Count);
                let goods = _data.find(f => f.EntpTempGoodsId == row.EntpTempGoodsId);
                if (goods) {
                    goods.GoodsLocationList.push({
                        ShelfSpaceId: row.ShelfSpaceId,
                        Count: intCount
                    });
                } else {
                    goods = {
                        EntpTempGoodsId: row.EntpTempGoodsId,
                        GoodsLocationList: [{ ShelfSpaceId: row.ShelfSpaceId, Count: intCount }]
                    };
                    _data.push(goods);
                }
            }
            this.dailogLoading = true;
            this.formData.GoodsList = _data;
            let url = "";
             if(this.isSaleOutOrderOut){
                url = '/api/EntpSaleOrder/ConfirmEntpSaleOutOrderOutWarehouse'
            }else{
                url = '/api/EntpSaleOrder/ConfirmEntpSaleOrderOutWarehouse'
            }
            this.$util
                .axiosPost({
                    url: url,
                    data: this.formData,
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg('出仓成功');
                    let IsAllOutWarehouse = res.data.IsAllOutWarehouse;
                    this.$emit('closeDialog', true, IsAllOutWarehouse);
                })
                .catch(() => {
                    this.dailogLoading = false;
                });
        },
        //仓库的变换
        warehouseChange(value, goods) {
            goods.ShelfSpacesList = [];
            goods.ShelfSpaceId = '';
        },
        //仓位的变换:选中值、商品、仓库
        positionChange(value, goods) {
            if (!value) return;
            var that = this;
            var filterArr = that.goodsList.filter(e => e.EntpTempGoodsId == goods.EntpTempGoodsId && e.ShelfSpaceId == value);
            if (filterArr.length > 1) {
                goods.ShelfSpaceId = '';
                this.$util.warningMsg('不能选相同仓位');
                return;
            }
            if (this.isTcckModel) {
                let idx = goods.ShelfSpacesList.findIndex(f => f.ShelfSpaceId === value);
                goods.KcCount = goods.ShelfSpacesList[idx].Count;
            }
        },
        delItem(index, goods) {
            let that = this;
            var filterArr = that.goodsList.filter(e => e.EntpTempGoodsId == goods.EntpTempGoodsId);
            if (filterArr.length > 1) {
                that.goodsList.splice(index, 1);
                that.getSpanArr();
            }
        },
        addItem(index, goods) {
            let that = this;
            let _target = that.goodsList;
            let usedCount = 0; //已选数量
            for (let i = 0; i < _target.length; i++) {
                if (_target[i].EntpTempGoodsId == goods.EntpTempGoodsId) {
                    if (!_target[i].ShelfSpaceId) {
                        that.$util.warningMsg('请选择仓位');
                        return;
                    }
                    if (!_target[i].Count || !_target[i].Count < 0) {
                        that.$util.warningMsg('请填写正确的数量');
                        return;
                    }
                    usedCount += Number(_target[i].Count);
                }
            }
            //当前商品可出库数量
            let canInCount = Number(goods.Count);
            //剩余数量
            let surplus = canInCount - usedCount;
            that.goodsList.splice(index + 1, 0, {
                EntpTempGoodsId: goods.EntpTempGoodsId,
                GoodName: goods.GoodName,
                APCode: goods.APCode,
                Count: surplus > 0 ? surplus : 0,
                WarehouseId: goods.WarehouseId,
                ShelfSpaceId: '',
                ShelfSpacesList: [],
                WarehouseList: [...goods.WarehouseList]
            });
            that.getSpanArr();
        },
        getSpanArr() {
            this.spanArr = [];
            this.pos = 0;
            for (var i = 0; i < this.goodsList.length; i++) {
                if (i === 0) {
                    this.spanArr.push(1);
                    this.pos = 0;
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (this.goodsList[i].EntpTempGoodsId === this.goodsList[i - 1].EntpTempGoodsId) {
                        this.spanArr[this.pos] += 1;
                        this.spanArr.push(0);
                    } else {
                        this.spanArr.push(1);
                        this.pos = i;
                    }
                }
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let sArr = row.ShelfSpacesList.filter(f => f.ShelfSpaceId === row.ShelfSpaceId);
            if (sArr[0] && sArr[0].Count < row.Count) {
                return { 'background-color': '#FFE8E8' };
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (!this.isTcckModel) {
                if (columnIndex === 0 || columnIndex === 1) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                        rowspan: _row,
                        colspan: _col
                    };
                }
            }
        }
    }
};
</script>
<style lang="less">
.warehouseOut-main {
    .el-table th {
        padding: 6px 0;
    }
    .el-table td {
        padding: 3px 0;
    }
}
</style>
<style lang="less" scoped>
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.ops-ctn {
    text-align: left !important;
}
.dialog-header {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tips {
    color: #f00;
    margin-top: 4px;
    display: flex;
    justify-content: start;
    font-size: 15px;
}
.dialog-footer {
    text-align: right;
}
.warehouseOut-main {
    padding-top: 15px;
    padding-bottom: 15px;
}
.table-title {
    .cell-item {
        width: 33.33%;
    }
    .div-table-cell {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
}
.div-table-row {
    position: relative;
    overflow: visible;
}
.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .cell-line {
        display: flex;
        width: 100%;
    }
    .cell-item {
        padding: 0 10px;
        width: 33%;
        width: inherit;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
</style>
